import { loggerFacet, ClientId } from '../facets/LoggerFacets';
import { IItemCacheThunkAction, IItemCacheDispatch, IItemCacheContext } from '../store/actions/ItemCacheActions';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { unpack } from '../models/Facet';

/**
 * Extracts sharing client id from the configuration.
 * @internal
 */
export function getSharingClientId(): IItemCacheThunkAction<string> {
    return (dispatch: IItemCacheDispatch, getState: () => IItemCacheState, context: IItemCacheContext) => {
        if (context && context.configuration) {
            const { logger } = unpack({
                logger: loggerFacet
            }, context.configuration);

            if (logger && logger.sharingClientId) {
                return ClientId[logger.sharingClientId];
            }
        }
        // If host did not provide sharingClientId, default to unknown
        return ClientId[ClientId.unknown];
    };
}
